module.exports = "<p>\n  results-review works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/patients/results-review.component.html
// module id = ./src/app/views/patients/results-review.component.html
// module chunks = main